import * as types from "store/snackbar/snackbarTypes";

const initialState = {
  open: false,
  message: '',
  actionType: '',
  actionText: '',
  className: 'default-snackbar',
}

const snackbarReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LOGIN_FAILED:
    case types.RESET_PASSWORD_SUCCEEDED:
    case types.SHOW_MESSAGE:
      return {
        ...state,
        open: true,
        className: action.payload.className ? action.payload.className : 'default-snackbar',
        ...action.payload,
      }
    case types.DISMISS_SNACKBAR:
      return {
        ...state,
        open: false,
        title: ''
      }
    default:
      return state
  }
}

export default snackbarReducer
